// 虫虫漫画 - 单页内容数据
// 所有封面为占位插画，后续可替换为真实漫画封面

export interface ComicItem {
  id: string;
  title: string;
  cover: string;
  type: 'guoman' | 'riman';
  status: '连载中' | '已完结';
  latest: string;
  views: string;
  tags: string[];
  intro: string;
  score: string;
}

export interface GenreItem {
  id: string;
  name: string;
  icon: string;
  desc: string;
  count: string;
  color: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

// 首页横幅背景
export const heroImage =
  'https://readdy.ai/api/search-image?query=stylized%20comic%20book%20collage%20wallpaper%20with%20floating%20story%20panels%2C%20cute%20chibi%20characters%20and%20sparkles%20on%20warm%20coral%20orange%20and%20amber%20gradient%20background%2C%20vibrant%20hand%20painted%20anime%20illustration%20style%2C%20soft%20glowing%20lights%20and%20ink%20brush%20textures%2C%20playful%20youthful%20mood%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=comic-hero-01&orientation=landscape';

// 题材分类
export const genres: GenreItem[] = [
  {
    id: 'rexue',
    name: '热血冒险',
    icon: 'ri-fire-line',
    desc: '少年成长、战斗冒险，燃向爆表，追更首选。',
    count: '1286部',
    color: 'from-primary-500 to-primary-300',
  },
  {
    id: 'lianai',
    name: '恋爱甜宠',
    icon: 'ri-heart-line',
    desc: '校园恋爱、都市甜宠，糖分满满的少女心治愈。',
    count: '964部',
    color: 'from-accent-500 to-accent-300',
  },
  {
    id: 'huanqi',
    name: '奇幻异界',
    icon: 'ri-sparkling-line',
    desc: '异世界、魔法、东方玄幻，脑洞大开。',
    count: '1102部',
    color: 'from-secondary-500 to-secondary-300',
  },
  {
    id: 'xuanyi',
    name: '悬疑烧脑',
    icon: 'ri-search-eye-line',
    desc: '推理探案、惊悚心理，反转不停猜不透。',
    count: '713部',
    color: 'from-primary-700 to-primary-400',
  },
  {
    id: 'gaoxiao',
    name: '搞笑日常',
    icon: 'ri-emotion-laugh-line',
    desc: '沙雕无厘头、治愈日常，笑着笑着就上头。',
    count: '846部',
    color: 'from-accent-600 to-accent-400',
  },
  {
    id: 'dushi',
    name: '都市现实',
    icon: 'ri-building-4-line',
    desc: '职场成长、现代都市，贴近生活的故事。',
    count: '621部',
    color: 'from-secondary-600 to-secondary-400',
  },
  {
    id: 'lishi',
    name: '历史古风',
    icon: 'ri-landscape-line',
    desc: '古代权谋、仙侠国风，东方韵味拉满。',
    count: '537部',
    color: 'from-primary-400 to-accent-400',
  },
  {
    id: 'kehuan',
    name: '科幻未来',
    icon: 'ri-rocket-2-line',
    desc: '末世机甲、星际探索，想象力无边。',
    count: '468部',
    color: 'from-secondary-700 to-primary-500',
  },
];

// 热门连载
export const hotSeries: ComicItem[] = [
  {
    id: 'hot-1',
    title: '踏星而行',
    cover:
      'https://readdy.ai/api/search-image?query=young%20hero%20with%20glowing%20sword%20standing%20on%20floating%20islands%20under%20a%20burning%20orange%20sky%2C%20stylized%20hand%20painted%20comic%20book%20cover%20illustration%2C%20warm%20coral%20and%20amber%20palette%2C%20dramatic%20rim%20light%2C%20cinematic%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=comic-hot-01&orientation=portrait',
    type: 'guoman',
    status: '连载中',
    latest: '第368话',
    views: '9.8亿',
    tags: ['热血', '冒险', '奇幻'],
    intro: '少年云舟意外获得星辉之力，踏上踏星寻亲的冒险之路，一路斩妖燃命。',
    score: '9.6',
  },
  {
    id: 'hot-2',
    title: '山雨来时',
    cover:
      'https://readdy.ai/api/search-image?query=melancholy%20girl%20holding%20a%20lantern%20in%20rainy%20ancient%20alley%2C%20stylized%20hand%20painted%20comic%20cover%20art%2C%20warm%20amber%20and%20terracotta%20tones%2C%20moody%20atmosphere%2C%20soft%20watercolor%20texture%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=comic-hot-02&orientation=portrait',
    type: 'guoman',
    status: '连载中',
    latest: '第241话',
    views: '6.2亿',
    tags: ['都市', '悬疑', '情感'],
    intro: '梅雨季的旧城，少女阿雨接手一家即将拆迁的旧书店，却发现书中藏着不为人知的秘密。',
    score: '9.4',
  },
  {
    id: 'hot-3',
    title: '绯色幻境',
    cover:
      'https://readdy.ai/api/search-image?query=girl%20in%20elegant%20kimono%20walking%20into%20a%20glowing%20dreamlike%20lantern%20market%20at%20night%2C%20stylized%20hand%20painted%20comic%20cover%20illustration%2C%20warm%20coral%20and%20rose%20palette%2C%20magical%20sparkles%2C%20soft%20bokeh%20lights%2C%20cinematic%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=comic-hot-03&orientation=portrait',
    type: 'riman',
    status: '连载中',
    latest: '第189话',
    views: '7.5亿',
    tags: ['奇幻', '恋爱', '异界'],
    intro: '平凡高中生小唯误入绯色幻境，成为守护这个世界的最后一位"绘梦者"。',
    score: '9.3',
  },
  {
    id: 'hot-4',
    title: '银河列车',
    cover:
      'https://readdy.ai/api/search-image?query=steampunk%20space%20train%20traveling%20through%20colorful%20nebula%20with%20two%20young%20adventurers%20at%20the%20window%2C%20stylized%20comic%20cover%20art%2C%20warm%20orange%20and%20gold%20palette%2C%20vibrant%20glowing%20stars%2C%20cinematic%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=comic-hot-04&orientation=portrait',
    type: 'riman',
    status: '连载中',
    latest: '第156话',
    views: '5.8亿',
    tags: ['科幻', '冒险', '治愈'],
    intro: '一辆只在午夜出发的银河列车，载着追梦的乘客穿行于星海之间。',
    score: '9.2',
  },
  {
    id: 'hot-5',
    title: '长安夜谭',
    cover:
      'https://readdy.ai/api/search-image?query=young%20detective%20with%20a%20feather%20fan%20in%20ancient%20Chinese%20capital%20night%20street%20with%20lanterns%20and%20shadows%2C%20stylized%20hand%20painted%20comic%20cover%20art%2C%20warm%20amber%20and%20terracotta%20palette%2C%20mysterious%20mood%2C%20cinematic%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=comic-hot-05&orientation=portrait',
    type: 'guoman',
    status: '连载中',
    latest: '第203话',
    views: '4.6亿',
    tags: ['历史', '悬疑', '古风'],
    intro: '盛唐长安，一桩桩离奇夜谭背后，隐藏着一个跨越朝代的惊天棋局。',
    score: '9.5',
  },
  {
    id: 'hot-6',
    title: '深夜食堂·猫',
    cover:
      'https://readdy.ai/api/search-image?query=cozy%20tiny%20night%20restaurant%20with%20an%20orange%20cat%20and%20warm%20steaming%20food%20bowls%2C%20stylized%20hand%20painted%20comic%20cover%20illustration%2C%20warm%20amber%20and%20caramel%20tones%2C%20soft%20glowing%20lamp%2C%20heartwarming%20mood%2C%20cinematic%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=comic-hot-06&orientation=portrait',
    type: 'riman',
    status: '连载中',
    latest: '第98话',
    views: '3.9亿',
    tags: ['治愈', '日常', '美食'],
    intro: '深夜开张的小馆子，一只会说话的橘猫掌柜，用一碗热汤换一段人间故事。',
    score: '9.1',
  },
];

// 国漫专区
export const guomanSeries: ComicItem[] = [
  {
    id: 'guo-1',
    title: '雾都刑警',
    cover:
      'https://readdy.ai/api/search-image?query=detective%20in%20trench%20coat%20silhouette%20under%20yellow%20streetlight%20in%20foggy%20night%20city%2C%20stylized%20hand%20painted%20comic%20cover%20art%2C%20warm%20amber%20and%20charcoal%20palette%2C%20tense%20moody%20atmosphere%2C%20cinematic%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=comic-guo-01&orientation=portrait',
    type: 'guoman',
    status: '已完结',
    latest: '全286话',
    views: '8.1亿',
    tags: ['悬疑', '都市', '刑侦'],
    intro: '雾都接连发生的离奇案件，刑警队长苏澈一步步揭开城市深处的真相。',
    score: '9.0',
  },
  {
    id: 'guo-2',
    title: '南巷烟火',
    cover:
      'https://readdy.ai/api/search-image?query=two%20young%20people%20sitting%20on%20a%20rooftop%20overlooking%20old%20town%20alley%20at%20sunset%2C%20stylized%20comic%20cover%20illustration%2C%20warm%20coral%20and%20golden%20palette%2C%20nostalgic%20youthful%20mood%2C%20soft%20glow%2C%20cinematic%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=comic-guo-02&orientation=portrait',
    type: 'guoman',
    status: '连载中',
    latest: '第175话',
    views: '5.4亿',
    tags: ['恋爱', '都市', '青春'],
    intro: '旧城改造前的老巷，少年林夏与邻居女孩许微在烟火气里一起长大。',
    score: '9.3',
  },
  {
    id: 'guo-3',
    title: '山海拾遗',
    cover:
      'https://readdy.ai/api/search-image?query=mythical%20qilin%20and%20misty%20mountains%20with%20a%20monk%20holding%20a%20scroll%2C%20stylized%20hand%20painted%20comic%20cover%20art%2C%20warm%20jade%20and%20amber%20palette%2C%20eastern%20fantasy%20mood%2C%20soft%20ink%20wash%2C%20cinematic%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=comic-guo-03&orientation=portrait',
    type: 'guoman',
    status: '连载中',
    latest: '第132话',
    views: '4.2亿',
    tags: ['奇幻', '古风', '冒险'],
    intro: '《山海经》里的异兽悄然现世，守书人少年踏遍九州封印凶兽。',
    score: '9.2',
  },
  {
    id: 'guo-4',
    title: '沧海明月',
    cover:
      'https://readdy.ai/api/search-image?query=swordsman%20with%20long%20hair%20facing%20a%20huge%20moon%20over%20the%20ocean%20on%20a%20cliff%2C%20stylized%20hand%20painted%20comic%20cover%20art%2C%20warm%20silver%20and%20amber%20palette%2C%20martial%20arts%20epic%20mood%2C%20cinematic%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=comic-guo-04&orientation=portrait',
    type: 'guoman',
    status: '已完结',
    latest: '全312话',
    views: '7.7亿',
    tags: ['武侠', '历史', '热血'],
    intro: '乱世江湖，孤剑客明月携一柄断剑，走过刀光剑影的江湖岁月。',
    score: '9.4',
  },
];

// 日漫专区
export const rimanSeries: ComicItem[] = [
  {
    id: 'rim-1',
    title: '林间灯塔',
    cover:
      'https://readdy.ai/api/search-image?query=lone%20lighthouse%20in%20a%20misty%20pine%20forest%20with%20a%20small%20boy%20holding%20a%20lamp%2C%20stylized%20hand%20painted%20comic%20cover%20art%2C%20warm%20amber%20and%20forest%20green%20palette%2C%20mysterious%20gentle%20mood%2C%20cinematic%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=comic-rim-01&orientation=portrait',
    type: 'riman',
    status: '连载中',
    latest: '第88话',
    views: '3.1亿',
    tags: ['奇幻', '治愈', '悬疑'],
    intro: '雾林深处的灯塔每晚亮起，为迷途者指路，也记录着每一段未了的心愿。',
    score: '9.2',
  },
  {
    id: 'rim-2',
    title: '春日信笺',
    cover:
      'https://readdy.ai/api/search-image?query=sakura%20petals%20falling%20on%20a%20girlish%20writing%20desk%20with%20letters%20and%20a%20cute%20boy%20reading%2C%20stylized%20comic%20cover%20illustration%2C%20warm%20rose%20and%20cream%20palette%2C%20romantic%20school%20mood%2C%20soft%20light%2C%20cinematic%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=comic-rim-02&orientation=portrait',
    type: 'riman',
    status: '连载中',
    latest: '第142话',
    views: '4.8亿',
    tags: ['恋爱', '校园', '青春'],
    intro: '毕业前一年，少女收到一封署名"春"的信，从此她的青春悄悄开始翻页。',
    score: '9.3',
  },
  {
    id: 'rim-3',
    title: '雾谷来信',
    cover:
      'https://readdy.ai/api/search-image?query=postman%20on%20a%20bicycle%20riding%20through%20a%20foggy%20mountain%20valley%20village%2C%20stylized%20hand%20painted%20comic%20cover%20art%2C%20warm%20amber%20and%20muted%20teal%20palette%2C%20nostalgic%20mysterious%20mood%2C%20cinematic%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=comic-rim-03&orientation=portrait',
    type: 'riman',
    status: '已完结',
    latest: '全120话',
    views: '2.9亿',
    tags: ['治愈', '悬疑', '日常'],
    intro: '山间小村的邮差，每天把迟到的信送到人们手中，也替他们传递说不出口的心意。',
    score: '9.0',
  },
  {
    id: 'rim-4',
    title: '纸鸢',
    cover:
      'https://readdy.ai/api/search-image?query=two%20kids%20flying%20a%20red%20kite%20in%20a%20golden%20wheat%20field%20under%20warm%20sunset%2C%20stylized%20comic%20cover%20illustration%2C%20warm%20coral%20and%20gold%20palette%2C%20heartwarming%20nostalgic%20mood%2C%20cinematic%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=comic-rim-04&orientation=portrait',
    type: 'riman',
    status: '连载中',
    latest: '第64话',
    views: '2.1亿',
    tags: ['治愈', '成长', '日常'],
    intro: '乡下奶奶教小满扎纸鸢、晒谷子，小满也渐渐明白什么叫"慢慢长大"。',
    score: '8.9',
  },
];

// 经典全本
export const classicSeries: ComicItem[] = [
  {
    id: 'cls-1',
    title: '青鸟书',
    cover:
      'https://readdy.ai/api/search-image?query=ancient%20leather%20book%20with%20a%20glowing%20blue%20bird%20perched%20on%20it%20in%20a%20cozy%20library%2C%20stylized%20hand%20painted%20comic%20cover%20art%2C%20warm%20amber%20and%20teal%20palette%2C%20magical%20mood%2C%20soft%20glow%2C%20cinematic%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=comic-cls-01&orientation=portrait',
    type: 'riman',
    status: '已完结',
    latest: '全280话',
    views: '10.5亿',
    tags: ['奇幻', '冒险', '经典'],
    intro: '一本会说话的书，一只青鸟，一段跨越百年的守护之旅，日漫经典之作。',
    score: '9.7',
  },
  {
    id: 'cls-2',
    title: '流萤记',
    cover:
      'https://readdy.ai/api/search-image?query=fireflies%20drifting%20over%20a%20night%20river%20with%20two%20silhouettes%20on%20a%20wooden%20boat%2C%20stylized%20hand%20painted%20comic%20cover%20art%2C%20warm%20amber%20and%20deep%20green%20palette%2C%20nostalgic%20summer%20mood%2C%20cinematic%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=comic-cls-02&orientation=portrait',
    type: 'guoman',
    status: '已完结',
    latest: '全196话',
    views: '6.8亿',
    tags: ['恋爱', '青春', '经典'],
    intro: '萤火虫飞舞的夏夜，一段关于告别与重逢的青春恋曲，国漫经典。',
    score: '9.5',
  },
  {
    id: 'cls-3',
    title: '墨白',
    cover:
      'https://readdy.ai/api/search-image?query=ink%20painting%20style%20of%20a%20white%20horse%20running%20through%20misty%20ink%20mountains%2C%20stylized%20comic%20cover%20art%2C%20warm%20amber%20and%20charcoal%20ink%20palette%2C%20zen%20ancient%20mood%2C%20cinematic%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=comic-cls-03&orientation=portrait',
    type: 'guoman',
    status: '已完结',
    latest: '全260话',
    views: '7.9亿',
    tags: ['武侠', '古风', '经典'],
    intro: '黑白两色勾勒的江湖，少年墨白以笔为剑，写尽江湖儿女情长。',
    score: '9.6',
  },
  {
    id: 'cls-4',
    title: '月落',
    cover:
      'https://readdy.ai/api/search-image?query=full%20moon%20rising%20over%20a%20quiet%20village%20with%20a%20lone%20girl%20on%20the%20rooftop%2C%20stylized%20hand%20painted%20comic%20cover%20art%2C%20warm%20silver%20and%20amber%20palette%2C%20peaceful%20bittersweet%20mood%2C%20cinematic%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=comic-cls-04&orientation=portrait',
    type: 'riman',
    status: '已完结',
    latest: '全142话',
    views: '5.5亿',
    tags: ['奇幻', '治愈', '经典'],
    intro: '月落之时，小镇的人们会失去一段记忆；只有她记得，也只有在月光下说再见。',
    score: '9.4',
  },
];

// 常见问题
export const faqs: FaqItem[] = [
  {
    q: '虫虫漫画的题材分类到底有多全？',
    a: '虫虫漫画把国漫、日漫按热血冒险、恋爱甜宠、奇幻异界、悬疑烧脑、搞笑日常、都市现实、历史古风、科幻未来等大类和细分题材做了全面整理，无论是热门连载还是经典全本都能按分类快速定位，找书省时省力。',
  },
  {
    q: '怎样快速找到想看的连载漫画？',
    a: '你可以通过首屏的搜索框输入书名或题材关键词，也可以直接点击顶部的"题材分类"入口进入对应分类，热门连载会按人气自动排序，帮你第一时间看到更新最火的作品。',
  },
  {
    q: '国漫和日漫的专区有什么不同？',
    a: '国漫专区聚焦国内原创漫画，涵盖古风武侠、都市职场等本土题材；日漫专区则收录日本经典与热门作品，包含恋爱、奇幻、治愈等风格，两个专区内容独立整理，切换标签即可浏览。',
  },
  {
    q: '经典全本和连载中的漫画怎么看？',
    a: '连载中的作品标注了最新章节与更新状态，方便追更；经典全本则为已完结作品，可以一口气读完。每部漫画都配有简介、标签与评分，帮助你判断是否合口味。',
  },
  {
    q: '收藏和阅读足迹在哪里？',
    a: '登录后即可收藏喜欢的漫画并自动记录阅读足迹，下次回来接着看。未登录时也可以直接浏览，收藏功能建议注册账号后使用，方便跨设备同步。',
  },
  {
    q: '如何向我推荐或反馈想看的漫画？',
    a: '如果你有想看却没找到的漫画，可通过页脚"联系我们"表单留言，我们会持续扩充分类与收录内容，让虫虫漫画的分类大全越来越全。',
  },
];

// 口碑评价
export const reviews = [
  {
    name: '追更人·小林',
    role: '热血漫爱好者',
    text: '虫虫漫画的分类真的太全了，热血、悬疑分得清清楚楚，我这种每周追十几部连载的人，找书效率翻倍。',
  },
  {
    name: '阿紫',
    role: '恋爱漫爱好者',
    text: '日漫专区整理得很用心，评分和简介都很准，我照着推荐一路补完了好多经典老番，体验超赞。',
  },
  {
    name: '深夜老书虫',
    role: '经典全本收藏控',
    text: '喜欢它把"经典全本"单独拎出来，不用大海捞针，一口气看完整部作品的感觉太爽了。',
  },
];

// 网站特色
export const features = [
  {
    icon: 'ri-archive-drawer-line',
    title: '分类细致',
    desc: '大分类 + 细分题材双重整理，热门连载、经典全本按类直达。',
  },
  {
    icon: 'ri-restart-line',
    title: '追更方便',
    desc: '连载状态与最新章节一目了然，随时回到上次看到的地方。',
  },
  {
    icon: 'ri-star-smile-line',
    title: '评分推荐',
    desc: '每部作品都有简介、标签与口碑评分，帮你快速判断口味。',
  },
  {
    icon: 'ri-earth-line',
    title: '国漫日漫',
    desc: '国漫、日漫双专区，本土原创与海外经典一站网罗。',
  },
];